// components/audio/AudioVisualizer.jsx
import React from 'react';
import { FaMicrophoneSlash, FaStop } from 'react-icons/fa';

export default function AudioVisualizer({
  isRecording,
  isPlayingAudio,
  elapsedTime,
  onStopPlayback,
  onStopRecording,
}) {
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  return (
    <div className="flex items-center justify-between px-4 py-2">
      {/* Recording Indicator */}
      {isRecording && (
        <div className="flex items-center space-x-2">
          <div className="flex space-x-1">
            <div className="w-1 h-4 bg-red-500 animate-pulse rounded"></div>
            <div className="w-1 h-4 bg-red-500 animate-pulse rounded delay-75"></div>
            <div className="w-1 h-4 bg-red-500 animate-pulse rounded delay-150"></div>
          </div>
          <span className="text-sm text-red-600 font-medium">
            Recording {formatTime(elapsedTime)}
          </span>
          <button
            onClick={onStopRecording}
            className="p-1 hover:bg-red-100 rounded-full transition-colors"
            aria-label="Stop Recording"
          >
            <FaMicrophoneSlash className="w-4 h-4 text-red-600" />
          </button>
        </div>
      )}

      {/* Playback Indicator */}
      {isPlayingAudio && (
        <div className="flex items-center space-x-2">
          <div className="flex space-x-1">
            <div className="w-1 h-4 bg-indigo-500 animate-pulse rounded"></div>
            <div className="w-1 h-4 bg-indigo-500 animate-pulse rounded delay-75"></div>
            <div className="w-1 h-4 bg-indigo-500 animate-pulse rounded delay-150"></div>
          </div>
          <span className="text-sm text-indigo-600 font-medium">Playing</span>
          <button
            onClick={onStopPlayback}
            className="p-1 hover:bg-indigo-100 rounded-full transition-colors"
            aria-label="Stop Playback"
          >
            <FaStop className="w-4 h-4 text-indigo-600" />
          </button>
        </div>
      )}
    </div>
  );
}
